import React, { Component } from 'react';
import { getConfig } from '../../utils/helpers';
import { stockwaveClassNames } from '../../utils/widgets/stockwave';

export default class IDHorizontal extends Component {
  render() {
    if (getConfig('localization') === 'en-uk') {
      return (
        <span>
          <strong>REG:</strong> {this.props.stockNumber}
        </span>
      );
    }

    return (
      <span className={stockwaveClassNames.vin}>
        <strong>VIN:</strong> {this.props.vin}
      </span>
    );
  }
}
